
export const environment = {
  PRODUCTION: true,
  USE_MOCK_DATA: undefined,
  SENTRY_DSN_PUBLIC: 'https://ec4823dbe2e2453b9d1c726745788bda@sentry.io/194048',
  SENTRY_DSN: 'https://ec4823dbe2e2453b9d1c726745788bda:af9adb8484594b75ad31a74bcde88b0b@sentry.io/194048',
  CIRCLE_BRANCH: 'master',
  CIRCLE_BUILD_NUM: '2120',
  CIRCLE_SHA1: 'ee965cb102615bbce09bb62ce62da9582bd7bb5d',
  NODE_PORT: '3000',
  NGINX_PROXY_URL: 'https://careerpages.snagdev.com',
  EDGE_API_URL: 'http://career-pages-edge.api.snagprod.corp',
  APPLY_WEB_URL: 'https://www.snagajob.com/apply/posting',
  LAUNCH_DARKLY_ENV_KEY:  '59e124bf5dc0730aed81e34d',
  MEMCACHED_CLUSTER1: 'shared-a.cache.snagprod.corp:11211',
  MEMCACHED_CLUSTER2: 'shared-b.cache.snagprod.corp:11211',
  NOW_HIRING_DOMAIN: 'nowhiring.com',
  SWIMLANE_NAME: 'cp-display-web',
  ADOBE_DTM_URL: '//assets.adobedtm.com/a1470e381b6d77d8f2ab9e195ef356403b63e467/satelliteLib-7acd0b6da82676124f9ecdbec108e91c604d0d4d-staging.js',
  FACEBOOK_APP_ID: '611316579236728',
  LINKEDIN_CLIENT_ID: '773ry24qbatue3'
};
